import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitLead = (payload) => axios.post(`${API}/leads`, payload);
export const submitContact = (payload) => axios.post(`${API}/contact`, payload);
export const submitConsultation = (payload) =>
  axios.post(`${API}/consultation`, payload);
export const submitNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email });
